export default __webpack_public_path__ + "static/course-photo-3-f484fc922146199cea6a589cfca1d2e2.jpg";